import React, { Component } from "react";
import _ from "lodash";
import uuid from "react-uuid";
import Form from "react-bootstrap/Form";
import Loading from "../../../common/components/loading/loading";
import { getUserAccounts } from "../../../common/services/auth/userAccountService";
import SearchBox from "../../../common/components/search/searchBox";
import UserAccountsTable from "./userAccountsTable";
import { withTranslation } from "react-i18next";

class UserAccounts extends Component {
  constructor(props) {
    super(props);

    this.handleUserAccountUpdated = this.handleUserAccountUpdated.bind(this);
  }

  state = {
    userAccounts: [],
    searchQuery: "",
    activeOnly: true,
    sortColumn: { path: "login", order: "asc" },
    isLoading: true,
  };

  async componentDidMount() {
    this.setState({ userAccounts: await getUserAccounts(), isLoading: false });
  }

  handleSearch = (query) => {
    this.setState({ searchQuery: query });
  };

  handleSort = (sortColumn) => {
    this.setState({ sortColumn });
  };

  handleToggleActiveOnly = () => {
    this.setState({ activeOnly: !this.state.activeOnly });
  };

  handleUserAccountSelected = (userAccount, isNew = false) => {
    //Inject the callback function before calling back to the onClick event.
    this.props.onClick(userAccount, this.handleUserAccountUpdated, isNew);
  };

  handleUserAccountUpdated = (userAccount) => {
    const userAccounts = [...this.state.userAccounts];
    const index = userAccounts.findIndex(
      (u) => u.userAccountId === userAccount.userAccountId
    );
    if (index > -1) {
      userAccounts.splice(index, 1);
    }
    userAccounts.push(userAccount);
    this.setState({ userAccounts: userAccounts });
  };

  getFilteredData = () => {
    const {
      sortColumn,
      searchQuery,
      userAccounts: allUserAccounts,
      activeOnly,
    } = this.state;

    let filtered = allUserAccounts;

    if (activeOnly) filtered = filtered.filter((u) => u.active);

    if (searchQuery)
      filtered = filtered.filter(
        (u) =>
          (u.login != null &&
            u.login.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.firstName != null &&
            u.firstName.toLowerCase().includes(searchQuery.toLowerCase())) ||
          (u.lastName != null &&
            u.lastName.toLowerCase().includes(searchQuery.toLowerCase()))
      );

    const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    return { totalCount: filtered.length, data: sorted };
  };

  render() {
    const { searchQuery, sortColumn, activeOnly, isLoading } = this.state;

    if (isLoading) return <Loading />;

    const { t, allowEdit } = this.props;

    const { totalCount, data: userAccounts } = this.getFilteredData();

    const newUser = {
      userAccountId: uuid(),
      login: t("NewUser"),
    };

    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <SearchBox value={searchQuery} onChange={this.handleSearch} />
          </div>
          <div className="col">
            <Form.Switch
              className="switch"
              type="switch"
              label={t("ActiveOnly")}
              checked={activeOnly}
              value={activeOnly}
              onChange={this.handleToggleActiveOnly}
            />
          </div>
          <div className="col">
            {allowEdit && (
              <button
                onClick={() => this.handleUserAccountSelected(newUser, true)}
                className="btn btn-sm btn-primary float-sm-right"
              >
                {t("AddUserAccount")}
              </button>
            )}
          </div>
        </div>
        <p>{t("RetrievedUserAccount", { count: totalCount })}</p>
        <UserAccountsTable
          userAccounts={userAccounts}
          sortColumn={sortColumn}
          onSort={this.handleSort}
          onRowClick={this.handleUserAccountSelected}
        />
      </div>
    );
  }
}

export default withTranslation(["auth"])(UserAccounts);
